import {
    Component, Input, Output, EventEmitter,
    ViewChild, ViewChildren
} from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpParams, HttpEventType, HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';

import { ToastrService } from 'ngx-toastr';


//import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

//import { FormBuilder, FormGroup, Validators } from '@angular/forms';

//import { UserService } from '../../services/user.service';
//import { RegistrationDataService } from '../../services/registration.data.service';

//import { RegistrationValidationComponent } from '../../modals/sign_up_validation.modal/sign_up_validation.modal.component';

import { UserPostsDataService } from '../../services/posts.service';
import { SessionService } from '../../services/session.service';

import { PostFooterComponent } from '../../components/insertable/post-footer/post-footer.component';

import *  as Classes from '../../classes/models.classes'

@Component({
    selector: 'app-quote-modal',
    templateUrl: './quote-modal.component.html',
    styleUrls: ['./quote-modal.component.css']
})
export class QuoteModalComponent {
    @ViewChild('footerComponent') footerComponent!: PostFooterComponent;


    @Input() postData: any; // Receive the post data from the parent


    @Output() postEditedOrDeleted: EventEmitter<void> = new EventEmitter<void>();
    @Output() postQuote = new EventEmitter<string>(); // Emit the comment

    @Output() mediaUrlsChange = new EventEmitter<any[]>();
    @Output() replyTypeChange = new EventEmitter<any>();
    @Output() postContent = new EventEmitter<any>();
    @Output() onSave = new EventEmitter<void>();      

    comment: string = '';

    UserPostsDataContent: Classes.ShortsPostSave;

    UserID: number;
    Username: string;
    UserImg: string;

    FileName: string = 'logo.png'; //
    VideoMimeType: string = 'image/jpeg';
    selectedFile: File | null = null;

    mediaUrls: any[] = [];
    replyTypes = [
        { id: 1, text: 'Everyone', icon: 'path/to/everyone.svg' },
        { id: 2, text: 'Accounts You Follow', icon: 'path/to/accounts-follow.svg' },
        { id: 3, text: 'Verified Accounts', icon: 'path/to/verified-accounts.svg' },
        { id: 4, text: 'Only Accounts You Mention', icon: 'path/to/accounts-mention.svg' }
    ];

    selectedReplyType = this.replyTypes[0];  // default to Everyone

    hasPostText: boolean = false; // Tracks whether there is post text to enable post button

    constructor(
        private sessionService: SessionService,
        private userPostsDataService: UserPostsDataService,
        private toastr: ToastrService,
        public activeModal: NgbActiveModal
    ) { }

    ngOnInit(): void {

        this.sessionService.getUserID().subscribe(userID => {
            this.UserID = Number(userID);
        });

        this.sessionService.getUsername().subscribe(username => {
            this.Username = username;
        });

        this.sessionService.getUserImg().subscribe(userImg => {
            this.UserImg = userImg;
        });


        this.UserPostsDataContent = new Classes.ShortsPostSave();
    }

    updatePostContent(postContent: string) {
        this.UserPostsDataContent.PostContent = postContent;
        if (postContent && postContent.length > 0) {
            this.hasPostText = true;
        }

    }

    updatePostMediaUrls(media: any[]) {
        //this.mediaUrls = media;
        this.mediaUrls = media.map(item => ({ ...item })); // Shallow copy to avoid reference sharing

    }

    updateReplyType(type: any) {
        this.selectedReplyType = type;
    }

    removeMediaFromFooter(index: number): void {
        if (this.footerComponent) {
            this.footerComponent.removeMediaAtIndex(index);
        } else {
            console.error("FooterComponent not initialized yet.");
        }
    }

    triggerQuoteFileUpload(): void {
        document.getElementById('quoteMediaFileUpload')!.click();
    }

    checkQuoteMedia(event: any): void {
        this.selectedFile = event.target.files[0];

        if (!this.selectedFile) {
            return;
        }

        const fileType = this.selectedFile.type;

        //if (this.selectedFile) {
        // Handle videos
        if (this.selectedFile.type.startsWith('video/')) {
            // Check the file type
            if (this.selectedFile.type !== 'video/mp4' && this.selectedFile.type !== 'video/quicktime') {
                alert('Unsupported video format. Please upload a MP4 or MOV file.');
                return;
            }

            // Load the file into a video element to check duration
            const video = document.createElement('video');
            video.preload = 'metadata';

            video.onloadedmetadata = () => {
                window.URL.revokeObjectURL(video.src);
                const duration = video.duration;

                if (duration > 120) { // Check if video is longer than 2 minutes
                    alert('Video is too long. Maximum allowed duration is 2 minutes.');
                } else {
                    alert('Video is valid. Duration: ' + duration + ' seconds.');
                    // Proceed with further processing like uploading
                }
            };

            video.onerror = () => {
                alert('Unable to load the video for validation.');
            };

            video.src = URL.createObjectURL(this.selectedFile);

            return; // Exit function after handling video
        }

        // Handle images
        if (this.selectedFile.type.startsWith('image/')) {
            // Image-specific processing logic here

            if (this.selectedFile.type === 'image/gif') {
                alert('GIF file selected.');
                // Additional GIF-specific checks can go here
            } else {
                alert('Image file selected.');
            }

            // Proceed with further processing like uploading
        }
    }

    submitPost() {

        // Call checkVideo with the mock event

        this.UserPostsDataContent.UserID = this.UserID;
        this.UserPostsDataContent.OriginalPostID = this.postData.TSID;
        this.UserPostsDataContent.PostType = 5;
        this.UserPostsDataContent.PublishDate = new Date() // Date is set at the time of submission
        //if (this.selectedFile.name && this.selectedFile.name.length > 0) {
        //    this.UserPostsDataContent.FileName = this.selectedFile.name;
        //    this.UserPostsDataContent.VideoMimeType = this.selectedFile.type;
        //}

        const formData = new FormData();

        formData.append('postData', JSON.stringify(this.UserPostsDataContent)); // Serialize your object into a JSON string
        //if (this.selectedFile) {
        //    formData.append('file', this.selectedFile, this.selectedFile.name);
        //}
        // Add each media file or URL
        this.mediaUrls.forEach((mediaItem, index) => {
            if (!mediaItem.isTenor) {
                // Append local file
                formData.append(`file_${index}`, mediaItem.file!, mediaItem.file!.name);
                formData.append('mimeType', mediaItem.mimeType!);
            } else {
                // Append Tenor URL and Animated URL concatenated with a delimiter (e.g., `|`)
                const combinedUrl = `${mediaItem.url}|${mediaItem.animatedUrl}`;
                formData.append(`gifUrl_${index}`, combinedUrl);
            }
        });

        //this.userPostsDataService.saveQuotePost(formData).subscribe(data => {
        this.userPostsDataService.saveQuotePost(formData, this.UserID).subscribe({
            next: (response) => {
                //console.log('Post saved successfully', response);
                this.toastr.success('Post saved successfully!');

                // Reset post content and media URLs
                this.UserPostsDataContent.PostContent = '';
                this.mediaUrls = [];

                // Just refresh the posts
                this.handleSave();
            },
                error: (error) => {
                    //console.error('Error saving post', error);
                    this.toastr.error('Error saving post!');
                }        })
    };


    onPost(): void {
        this.postQuote.emit(this.comment); // Emit the comment to the parent component
        this.activeModal.close(); // Close the modal
    }

    onCancel(): void {
        this.activeModal.dismiss(); // Dismiss the modal without doing anything
    }

    handleSave(): void {
        //this.mediaUrlsChange.emit(this.mediaUrls);
        //this.replyTypeChange.emit(this.selectedReplyType);
        //this.postContent.emit(this.UserPostsDataContent.PostContent);
        //this.onSave.emit();

        this.UserPostsDataContent.OriginalPostID = this.postData.TSID;

        this.mediaUrlsChange.emit(this.mediaUrls);
        this.replyTypeChange.emit(this.selectedReplyType);
        this.postContent.emit(this.UserPostsDataContent);
        //this.onSave.emit();

        this.postEditedOrDeleted.emit();  // Pass event up to Dashboard

        this.activeModal.close(); // Close the modal

    }

}

